import { render, staticRenderFns } from "./BuyMenu.vue?vue&type=template&id=409cfb74&scoped=true"
import script from "./BuyMenu.vue?vue&type=script&lang=js"
export * from "./BuyMenu.vue?vue&type=script&lang=js"
import style0 from "./BuyMenu.vue?vue&type=style&index=0&id=409cfb74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409cfb74",
  null
  
)

export default component.exports